import { render, staticRenderFns } from "./reinspection.vue?vue&type=template&id=0d196580&scoped=true&"
import script from "./reinspection.vue?vue&type=script&lang=js&"
export * from "./reinspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d196580",
  null
  
)

export default component.exports